import styled from "styled-components";

export const SectionContainer = styled.div`
  display: flex;
  margin: 2rem;
  flex-direction: column;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  background-color: #fff;
  @media (max-width: 768px) {
    margin: 0.5rem;
  }
`;

export const SectionTitle = styled.div`
  width: 100%;
  height: 25%;
  padding: 1%;
  padding-left: 2%;
  font-size: 1.75rem;
  @media (max-width: 768px) {
    font-size: 1.2rem;
    padding: 3%;
  }
`;

export const SectionContent = styled.div`
  width: 100%;
  padding: 0% 2% 2% 2%;
`;
